<template lang="pug">
.vue-app-wizard
  .steps-wrapper
    AppTabs(
      v-if="editing"
      compact
      :selected-tab="selectedTab"
    )
      AppTab(
        v-for="(step, index) in steps"
        :key="index"
        :label="step.title"
        :tab-id="`tab-${index}`"
        :has-error="!!step.hasError"
        @tab-selected="tabSelected"
      )
    #wizard.steps(v-else)
      .lines-wrapper
        .step-line
      .step-segments-wrapper
        div(
          v-for="(step, index) in steps"
          :key="`step-${index}`"
          :class="stepClasses(index)"
        )
          .step-number-wrapper
            .step-number
              | {{ index + 1 }}
          .step-title
            | {{ step.title }}
  slot
</template>

<script>
export default {
  name: 'AppWizard',
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectedTab() {
      return `tab-${this.value}`;
    },
  },
  methods: {
    stepClasses(index) {
      const classes = ['step-segment'];

      if (this.value === index) {
        classes.push('active');
      }

      if (this.value > index) {
        classes.push('is-complete');
      }

      if (index === 0) {
        classes.push('is-first');
      }

      if (index === this.steps.length - 1) {
        classes.push('is-last');
      }

      return classes;
    },
    tabSelected(id) {
      this.$emit('tab-selected', id);
    },
  },
};
</script>
